import { useState, useContext, useEffect } from "react";
import UpdateVfcRenewal from "./Components/UpdateVfcRenewal";
import AuditVfc from "./Components/AuditVfc";
import ManageAuditRenewal from "./Components/ManageAuditRenewal";
import Meetings from "./Components/Meetings";
import { AuthContext } from "../../Context/AuthContext";

const TABS = [
  { key: "Meetings", label: "Meetings", icon: "mdi-calendar-check-outline" },
  { key: "Update VFC & Renewal", label: "Update VFC & Renewal", icon: "mdi-autorenew" },
  { key: "Audit Report", label: "Audit Report", icon: "mdi-clipboard-text-outline" },
  { key: "Manage Report and Renewal", label: "Manage Report & Renewal", icon: "mdi-table-search" },
];

const SERVICE_CHARGE_EXCLUDED_ROLES = [
  "Admin",
  "Super Admin",
  "DFO",
  "CCF",
];

const UpdateRenewalandAudit = () => {
  const [activeKey, setActiveKey] = useState("Meetings");
  const { role } = useContext(AuthContext);

  const visibleTabs = SERVICE_CHARGE_EXCLUDED_ROLES.includes(role)
    ? TABS.filter(tab => tab.key === "Manage Report and Renewal")
    : TABS;

  useEffect(() => {
    if (SERVICE_CHARGE_EXCLUDED_ROLES.includes(role)) {
      setActiveKey("Manage Report and Renewal");
    }
  }, [role]);
  return (
    <div>
      {/* ── Tab Bar ── */}
      <div style={{ display: "flex", gap: 2, borderBottom: "2px solid #E2E8F0", marginBottom: 20, overflowX: "auto" }}>
        {visibleTabs.map((tab) => {
          const isActive = activeKey === tab.key;
          return (
            <button
              key={tab.key}
              onClick={() => setActiveKey(tab.key)}
              style={{
                display: "flex", alignItems: "center", gap: 6,
                padding: "10px 18px", border: "none", background: "none",
                fontSize: 13, fontWeight: isActive ? 700 : 500,
                color: isActive ? "#1B5E20" : "#718096",
                borderBottom: isActive ? "2px solid #1B5E20" : "2px solid transparent",
                marginBottom: -2, cursor: "pointer", whiteSpace: "nowrap",
                transition: "all 0.2s",
              }}
            >
              <i className={`mdi ${tab.icon}`} style={{ fontSize: 15 }} />
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* ── Tab Content ── */}
      {!SERVICE_CHARGE_EXCLUDED_ROLES.includes(role) && (
        <>
          {activeKey === "Meetings" && <Meetings />}
          {activeKey === "Update VFC & Renewal" && <UpdateVfcRenewal />}
          {activeKey === "Audit Report" && <AuditVfc />}
        </>
      )}
      {activeKey === "Manage Report and Renewal" && <ManageAuditRenewal />}
    </div>
  );
};

export default UpdateRenewalandAudit;
